import { render, staticRenderFns } from "./CallNumber.vue?vue&type=template&id=1c804397&scoped=true&"
import script from "./CallNumber.vue?vue&type=script&lang=js&"
export * from "./CallNumber.vue?vue&type=script&lang=js&"
import style0 from "./CallNumber.vue?vue&type=style&index=0&id=1c804397&scoped=true&lang=scss&"
import style1 from "./CallNumber.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c804397",
  null
  
)

export default component.exports